import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import Button from "components/library/Button";

import { saveForm } from "editor/actions/status";

const mapStateToProps = state => ({
  isDirty: state.editor.status.isDirty,
  isSaving: state.editor.status.isSaving,
  isReadOnly: state.editor.status.isReadOnly,
});

const mapDispatchToProps = {
  saveForm,
};

function SaveButton(props) {
  let buttonText;

  if (props.isReadOnly) {
    buttonText = "Read only";
  } else {
    buttonText = !props.isDirty ? "Saved" : props.isSaving ? "Saving" : "Save";
  }

  return (
    <Button
      className="gtm-save"
      onClick={props.saveForm}
      isDisabled={!props.isDirty || props.isSaving || props.isReadOnly}
      type="tertiary"
      data-cy="saveButton"
    >
      {buttonText}
    </Button>
  );
}

SaveButton.propTypes = {
  isDirty: PropTypes.bool.isRequired,
  isSaving: PropTypes.bool.isRequired,
  saveForm: PropTypes.func.isRequired,
  isReadOnly: PropTypes.bool,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SaveButton);
